import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ConfirmationDialogComponent} from './confirmation-dialog/confirmation-dialog.component';
import {FailedActionDialogComponent} from './failed-action-dialog/failed-action-dialog.component';
import {MatDividerModule} from '@angular/material/divider';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {DialogModule} from '../components/dialog/dialog.module';
import { TableColumnsConfigurationDialogComponent } from './table-columns-configuration-dialog/table-columns-configuration-dialog.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {FormsModule} from '@angular/forms';
import {InformationDialogComponent} from './information-dialog/information-dialog.component';
import {OneTimeConfirmationDialogComponent} from './one-time-confirmation-dialog/one-time-confirmation-dialog.component';
import {ChartDialogComponent} from './chart-dialog/chart-dialog.component';
import {HighchartModule} from '../utils/highchart/highchart.module';
import {SortableListDialogComponent} from './sortable-list-dialog/sortable-list-dialog.component';
import {SortableListComponent} from './sortable-list-dialog/sortable-list/sortable-list.component';
import {VirtualScrollerModule} from 'ngx-virtual-scroller';
import {InfraModule} from 'ac-infra';
import { FailedMultipleActionsDialogComponent } from './failed-multiple-actions-dialog/failed-multiple-actions-dialog.component';
import {MaterialModule} from '../material.module';
import { AboutDialogComponent } from './about-dialog/about-dialog.component';



@NgModule({
  declarations: [
    ConfirmationDialogComponent,
    FailedActionDialogComponent,
    TableColumnsConfigurationDialogComponent,
    InformationDialogComponent,
    OneTimeConfirmationDialogComponent,
    ChartDialogComponent,
    SortableListDialogComponent,
    SortableListComponent,
    FailedMultipleActionsDialogComponent,
    AboutDialogComponent
  ],
  imports: [
    CommonModule,
    DialogModule,
    FormsModule,
    HighchartModule,
    VirtualScrollerModule,
    InfraModule,
    MaterialModule
  ],
  exports: [
    ConfirmationDialogComponent,
    FailedActionDialogComponent,
    FailedMultipleActionsDialogComponent,
    SortableListComponent
  ]
})
export class DialogsModule { }
